//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class LetterTypeService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[LetterType.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/aut/letter-type/detail', {'params':params});
	};

	//GeneratorFlag:[LetterType.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/aut/letter-type/list', {'params':params});
	};

//GeneratorFlag:[NewAction]
}